import React, { useEffect, useContext, useState,  } from 'react';
import Countdown from 'react-countdown';
import { useNavigate, useLocation } from 'react-router-dom';
import { externalAddress, AppSettings, botspotAddress } from '../../config/app-settings.js';

function PagesComingSoon() {
	const context = useContext(AppSettings);
	const navigate = useNavigate();
	let currentDate = new Date();
  	let currentYear = currentDate.getFullYear();

	const location = useLocation();

  	const [telefone, setTelefone] = useState('');

  	function enviar() {

		const query = new URLSearchParams(location.search);
		const to = query.get('to');

		fetch(externalAddress+'/api/usuario/telefone', {
			method: 'POST',
			body: JSON.stringify({
				telefone: telefone,
			}),
			headers: {
			'Content-Type': 'application/json',
			'HTTP-AUTHORIZATION': localStorage.getItem("bs_token")
		}}).then(res => {
			if (res.status == 401) {
				localStorage.clear();
				window.location.href = botspotAddress+'/login?to='+to;
			}
			if (res.status == 403) {
				localStorage.clear();
				window.location.href = botspotAddress+'/login?to='+to;
			}
			return res.json()
		})
		.then((result) => { 
			navigate(to);
		});

	}
	
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentClass('p-0');
		
		return function cleanUp() {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentClass('');
		};
		
		// eslint-disable-next-line
	}, []);
  
	return (
		<div className="coming-soon">
			<div className="flex-1">
				
				
				<div className="coming-soon-content">
					<div className="flex-1 mb-5">
						<h2 className="mb-3">Complete seu Cadastro</h2>
						<p className="mb-5">Para utilizar todos os recursos da biblioteca de setups <br/> Por favor, complete seu cadastro, informado seu telefone</p>
						<div className="input-group mb-2 w-300px mx-auto">
							<input type="text" onChange={(e) => setTelefone(e.target.value)} className="form-control" placeholder="Telefone" />
							<button type="submit" onClick={enviar} className="btn btn-theme fw-semibold">Enviar</button>
						</div>
					</div>
				</div>
				<div className="text-center small mt-5 pt-1 mb-n5">
					&copy; { currentYear } Data n' Quant
				</div>
			</div>
		</div>
	)
}

export default PagesComingSoon;